module.exports = __webpack_public_path__ + "media/images/marketing/patricia_robertson-1d68b41b5a4af59e2eda2766ed7fd2a96abd29b112aa3dbbb79ec6b6723a2526.jpg";